import React from "react";
import { useAuth } from "../../context/AuthContext";
import { PLATFORM_BRAND } from "../../config/platformBrand";
import "./platform-identity.css";

// Read-only presentation inside existing Owner views; not an authorization boundary.
// Does not write settings, alter document metadata or replace tenant/agent branding.
export const PlatformIdentity = ({ context }) => {
  const { user } = useAuth();
  if (user?.role !== "owner") return null;
  const id = `platform-identity-${context}`;
  return (
    <section className="platform-identity" aria-labelledby={`${id}-name`} data-testid={id}>
      <div className="platform-identity__logo-surface">
        <img src={PLATFORM_BRAND.assets.dashboard} alt={`${PLATFORM_BRAND.name} — officieel logo`}
          width="768" height="768" className="platform-identity__logo" data-testid={`${id}-logo`} />
      </div>
      <div className="platform-identity__content">
        <p className="platform-identity__eyebrow" data-testid={`${id}-scope`}>SaaS-platform · Platform Owner</p>
        <h2 id={`${id}-name`} className="font-chivo platform-identity__name" data-testid={`${id}-name`}>{PLATFORM_BRAND.name}</h2>
        <p className="platform-identity__tagline" data-testid={`${id}-tagline`}>{PLATFORM_BRAND.tagline}</p>
        <dl className="platform-identity__facts">
          <div><dt>Platformeigenaar</dt><dd data-testid={`${id}-owner`}>{PLATFORM_BRAND.owner}</dd></div>
          <div><dt>Eerste operationele tenant</dt><dd data-testid={`${id}-tenant`}>{PLATFORM_BRAND.firstOperationalTenant}</dd></div>
        </dl>
        <details className="platform-identity__story" data-testid={`${id}-story`}>
          <summary data-testid={`${id}-story-toggle`}>Merkidentiteit</summary>
          <p data-testid={`${id}-pronunciation`}>Uitspraak: {PLATFORM_BRAND.pronunciation}</p>
          <dl className="platform-identity__meanings">
            {PLATFORM_BRAND.meaning.map(({ key, value }) => (
              <div key={key} data-testid={`${id}-meaning-${key.toLowerCase()}`}><dt>{key}</dt><dd>{value}</dd></div>
            ))}
          </dl>
          <p className="platform-identity__notice" data-testid={`${id}-story-notice`}>{PLATFORM_BRAND.storyNotice}</p>
        </details>
      </div>
    </section>
  );
};